import { useNavigate } from 'react-router-dom';
import { skipToken } from '@reduxjs/toolkit/query';
import { RootStateOrAny, useSelector } from 'react-redux';
import React from 'react';
import { PermissionsUtil } from '../../../utils/permissions/permissionsUtil';
import { PERMISSIONS } from '../../../constants/permissions/Permissions.constants';
import { useListProperShippingNameQuery } from '../../../services/organizations/organizations.service';

const UseProperShippingNameGrid = () => {
    const navigate = useNavigate();
    const user = useSelector((state: RootStateOrAny) => state.user);

    const {
        data: properShippingNameList,
        isLoading: isLoadingProperShippingName,
    } = useListProperShippingNameQuery(
        user?.businessEntity?.id
            ? user?.businessEntity?.id.toString()
            : skipToken
    );

    const canCreateProperShippingName = PermissionsUtil.isPermissionEnabled(
        user.permissions,
        PERMISSIONS.SETUP.PROPER_SHIPPING_NAME.CREATE
    );

    const canViewProperShippingName = PermissionsUtil.isPermissionEnabled(
        user.permissions,
        PERMISSIONS.SETUP.PROPER_SHIPPING_NAME.VIEW
    );

    const redirectToForm = (row: any) => {
        if (row?.id) {
            navigate(`/setup/properShippingName/${row.id}`);
        } else {
            navigate('/setup/properShippingName/new');
        }
    };

    return {
        redirectToForm,
        properShippingNameList,
        isLoadingProperShippingName,
        canCreateProperShippingName,
        canViewProperShippingName,
    };
};

export default UseProperShippingNameGrid;
